import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import * as actions from '../actions';
import { apiMethods } from '../services/api';
import { apiMethodsConst } from '../services/methods';
import { NumberUtils } from '~/utils/NumberUtils';

type TApiMethodKey = keyof typeof apiMethods;

function* callAndDispatchPayload(method: TApiMethodKey, payload?: any): Generator<any, any, any> {
  yield call(apiMethods[method], payload);
  yield put({ type: method, payload });
}

function* watchRequestReport(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.REQUEST_REPORT_ACTION);

  function* handler({
    payload,
  }: {
    payload: { email: string; ranges: any; notes: string };
  }): Generator<any, void, any> {
    yield put({ type: events.REQUEST });

    try {
      yield* callAndDispatchPayload(apiMethodsConst.REQUEST_PAYMENT_REPORT, {
        email: payload.email,
        dateRange: payload.ranges,
        notes: payload.notes,
      });

      yield put({
        type: actions.SHOW_MESSAGE,
        payload: {
          action: actions.REQUEST_REPORT_ACTION,
          title: 'Request Submitted Successfully!',
          message:
            // eslint-disable-next-line max-len
            `Your transaction report request was submitted successfully. Our team will do our best to return the report within 3-5 business days. If needed sooner, please text ${NumberUtils.getCSPhone().formatted} for assistance.`,
          isSuccess: true,
        },
      });
      yield put({ type: events.SUCCESS });
    } catch (e: any) {
      yield put({ type: events.FAILURE, payload: e });
    }
  }

  yield takeEvery(actions.REQUEST_REPORT_ACTION, handler as any);
}

export default function* sagaPayments(): Generator<any, void, any> {
  yield all([fork(watchRequestReport)]);
}
